<template>
    <el-dialog
        :visible="isVisible"
        @close="hide"
        :title="title"
        :destroy-on-close="true"
    >
        <loading v-if="!isInitialized"></loading>
        <contact-hold-form
            v-if="isInitialized"
            v-bind="formData"
            @stored="onStored"
        ></contact-hold-form>
    </el-dialog>
</template>

<script>
  import BaseDialogFormWrapper from '../../components/dialog-form-wrapper';
  import ContactHoldForm from '../../components/contact-hold/form';
  import Loading from '../../components/loading';
  import eventBus from '../../event-bus';

  export default {
    extends: BaseDialogFormWrapper,

    components: {
      Loading,
      ContactHoldForm
    },

    computed: {
      /**
       * @return {string}
       */
      title() {
        if (!this.isInitialized) {
          return 'Loading ...';
        } else if (_.get(this.formData, 'model.id')) {
          return 'Edit Contact Hold'
        }

        return 'Create Contact Hold'
      },
    },

    methods: {
      /**
       * @param {string|undefined} message
       */
      onStored({message}) {
        _.isString(message) && this.$message.success(message);
        this.hide();
        eventBus.$emit('refresh-contact-hold-table');
      },
    },

    created() {
      eventBus.$on('show-add-contact-hold-dialog', this.show);
    },

    beforeDestroy() {
      eventBus.$off('show-add-contact-hold-dialog', this.show);
    }
  }
</script>

<style scoped>

</style>
